// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3-cF9","modalForm":"UpgradeEpcsModal_modalForm__2_DMG","modalFooter":"UpgradeEpcsModal_modalFooter__aL0eC"};